import React from 'react';

import { Button } from '@ontruck/orc';
import { injectIntl } from 'react-intl';

const UnassignButton = ({ isUnassigning, onUnassignClick, intl }) => {
  const t = intl.messages.modules.statusInfo;
  return (
    <Button noWrap ghost text={t.unassign} onClick={onUnassignClick} disabled={isUnassigning} />
  );
};

export default injectIntl(UnassignButton);
